export default {
  sideBar: {
    account: 'Account',
    library: 'Library',
    releases: 'Releases',
    templates: 'Templates',
    subscription: 'Subscription',
    youTubeChannel: 'YouTube Channel',
    youTube: 'YouTube',
    logOut: 'Log Out',
  },
  release: {
    newRelease: '+ New Release',
  },
  delete: {
    buttonText: 'Delete Account',
    title: 'Delete Account?',
    description: `Are you sure you want to delete your account?
This action can’t be undone. You will lose access to your library.`,
  },
  accountDeletedModal: {
    title: 'Success!',
    description: 'Your account has been successfully deleted.',
  },
  subscription: {
    title: 'Subscription Status',
    upgradeAccount: 'Upgrade to get the best out of Loudly’s features.',
    accountType: 'Account type:',
    productName: '<0>{{ productName }}</0>',
    annual: 'Annual',
    monthly: 'Monthly',
    nextInvoiceDate: 'Next invoice date:',
    subscriptionEnd: '<0>{{ productEndDate }}</0>',
    nextInvoiceAmount: 'Next invoice amount:',
    planEndOn: 'Your plan will end on:',
    subscriptionCancelled: 'Your plan will end on <0>{{ productEndDate }}</0>',
    subscriptionPrice: '<0>{{ productPrice }}</0>',
    accountLimits: 'Account Limits',
    allowancesReset: 'Allowances will reset on ',
    action: 'Action',
    allowance: 'Allowance',
    currentUsage: 'Current Usage',
    aiTrackCreations: 'AI Track Creations',
    trackDownloads: 'Track Downloads',
    stemPackDownloads: 'Stem Pack Downloads',
    samplePackDownloads: 'Sample Pack Downloads',
    tracksReleased: 'Tracks Released',
    limited: 'Limited',
    limitsError: 'Error fetching account limits.',
    resetDateError: 'Error fetching reset date.',
    manage: 'Manage Subscription',
    viewPricingAndPlans: 'View Pricing and Plans',
    subscription: 'Subscription',
    cancel: 'Cancel Subscription',
    cancelSubscriptionModal: {
      title: 'Thinking of canceling?',
      description: `Remember, that means saying goodbye to the licensed songs you've downloaded or generated using Loudly.
      
      To avoid any disruption to your projects and potential copyright issues, we recommend exploring other plans instead.`,
      dismiss: 'Dismiss',
      continue: 'Continue',
    },
  },
  youtubeChannel: {
    title: 'YouTube Channel',
    upgradeContainer: {
      title: 'Whitelist your YouTube channel',
      avoidCopyrightClaims: 'Avoid copyright claims',
      monetizeYourContent: 'Monitize your YouTube content',
      upgrade: 'Upgrade',
    },
    whitelistContainer: {
      title: 'Whitelist YouTube Account',
      description:
        'Ensure your channel is whitelisted to avoid copyright claims.',
      label: 'YouTube URL',
      placeholder: 'https://www.youtube.com/@yourusername',
      submit: 'Submit',
      statusMessage: {
        accepted: 'URL whitelisted',
        pending: 'URL pending approval.',
        declined: 'URL rejected, please try another.',
        invalidURL:
          'Invalid YouTube channel URL format. Expected format: https://www.youtube.com/@youtubeChannelName',
      },
      confirmationDialog: {
        title: 'Confirm submission',
        description:
          'By confirming your YouTube url, your channel will be whitelisted and all audio used within your content will be exempt from any copyright claims. This cannot be changed.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      helperText: 'If you require additional URLs to be whitelisted, please ',
      getInTouch: 'get in touch',
    },
  },
};
